module.exports = __webpack_public_path__ + "b79c548f6307fc8a4064622b5c573cb5.svg";